import BabylonScene from '../components/BabylonScene';

const VRGalleryPage = () => {
  return (
    <BabylonScene />
  );
};

export default VRGalleryPage;
